export function useFundedThreshold(goalResource) {
  const funded = +goalResource.attr('funded');
  const thresholds = goalResource.attr('zoneMinimums').resources().list().slice(0)
    .sort((a, b) => b.attr('minimum') - a.attr('minimum'));
  return {
    funded,
    threshold: thresholds.find(t => funded >= t.attr('minimum')),
  };
}
